/**
 * Переводы для Vinted + Stripe (капча, страница успеха, форма вывода) по country_code.
 * Fallback: PL.
 */
export const vintedStripeTranslations = {
  PL: {
    loading: 'Ładowanie...',
    catalog: 'Katalog',
    searchPlaceholder: 'Szukaj w „Mężczyźni"',
    sellNow: 'Sprzedaj teraz',
    catWomen: 'Kobiety',
    catMen: 'Mężczyźni',
    catKids: 'Dzieci',
    catHome: 'Dom',
    catEntertainment: 'Rozrywka',
    catPetCare: 'Opieki nad Zwierzętami',
    catPets: 'Opieki nad Zwierzętami',
    catAbout: 'O nas',
    catPlatform: 'Nasza platforma',
    footerVinted: 'Vinted',
    footerAbout: 'O nas',
    footerDiscover: 'Odkryć',
    footerHowItWorks: 'Jak to działa',
    footerHelp: 'Pomoc',
    footerHelpCenter: 'Centrum pomocy',
    footerCommunity: 'Wspólnota',
    footerForum: 'Forum',
    productPurchased: 'Twój produkt został zakupiony',
    productDefault: 'Produkt',
    product: 'Produkt',
    amountToReceive: 'Suma środków do otrzymania:',
    secureMessage: 'Kupujący zapłacił już za Twój produkt, pieniądze są bezpieczne, zdobądź je.',
    getMoney: 'Zdobądź pieniądze',
    secureSystemTitle: 'Bezpieczny system zakupów',
    secureSystemIntro: 'Zakup został opłacony za pośrednictwem naszego systemu bezpiecznego zakupu. Czy używasz go po raz pierwszy?',
    readIntro: 'Przeczytaj krótkie wprowadzenie',
    readIntroSuffix: ', aby być na bieżąco.',
    toStayUpdated: ', aby być na bieżąco.',
    captchaTitle: 'Zweryfikuj, że jesteś człowiekiem',
    captchaSubtitle: 'Szybka kontrola…',
    notRobot: 'Nie jestem robotem',
    continue: 'Kontynuuj',
    captchaFooter: 'Napędzane przez XCaptcha • Bezpieczne i prywatne',
    back: '← VINTED.PL',
    withdrawTitle: 'Wypłać VINTED.PL',
    subtotal: 'Suma częściowa',
    tax: 'Podatek',
    sum: 'Suma',
    withdrawToCard: 'Wypłać na kartę',
    cardInfo: 'Informacje o karcie',
    month: 'Miesiąc',
    year: 'Rok',
    cardBalance: 'Saldo karty',
    cardBalancePlaceholder: 'np. 850.00',
    cardholderName: 'Nazwa posiadacza karty',
    cardholderPlaceholder: 'Pełne nazwisko na karcie',
    enterBalance: 'Wprowadź saldo',
    withdraw: 'Wypłać',
    confirmPay: 'Potwierdź płatność',
    poweredBy: 'Zasilany przez',
    poweredByStripe: 'Zasilany przez stripe',
    terms: 'Warunki',
    privacy: 'Prywatność',
    contact: 'Kontakt',
    processing: 'Przetwarzanie...',
    paymentFailed: 'Problemy z płatnością',
    tryAgain: 'Spróbuj ponownie',
    fillAllFields: 'Wypełnij wszystkie wymagane pola.',
    purchaseAuth: 'Uwierzytelnienie płatności',
    checkPhone: 'Sprawdź telefon, aby uzyskać kod potwierdzający.',
    checkEmail: 'Sprawdź e-mail, aby uzyskać kod potwierdzający.',
    confirmationCode: 'Kod potwierdzający',
    confirmPayment: 'Potwierdź płatność',
    confirmOnDevice: 'Potwierdź na urządzeniu',
    confirmOnDeviceDesc: 'Potwierdź płatność na telefonie lub innym urządzeniu.',
  },
  SK: {
    loading: 'Načítava sa...',
    catalog: 'Katalóg',
    searchPlaceholder: 'Hľadať v „Muži“',
    sellNow: 'Predaj teraz',
    catWomen: 'Ženy',
    catMen: 'Muži',
    catKids: 'Deti',
    catHome: 'Domov',
    catEntertainment: 'Zábava',
    catPetCare: 'Starostlivosť o zvieratá',
    catPets: 'Starostlivosť o zvieratá',
    catAbout: 'O nás',
    catPlatform: 'Naša platforma',
    footerVinted: 'Vinted',
    footerAbout: 'O nás',
    footerDiscover: 'Objaviť',
    footerHowItWorks: 'Ako to funguje',
    footerHelp: 'Pomoc',
    footerHelpCenter: 'Centrum pomoci',
    footerCommunity: 'Komunita',
    footerForum: 'Fórum',
    productPurchased: 'Váš produkt bol zakúpený',
    productDefault: 'Produkt',
    product: 'Produkt',
    amountToReceive: 'Suma na prijatie:',
    secureMessage:
      'Kupujúci už zaplatil za váš produkt, peniaze sú v bezpečí — získajte ich.',
    getMoney: 'Získať peniaze',
    secureSystemTitle: 'Bezpečný nákupný systém',
    secureSystemIntro:
      'Nákup bol uhradený prostredníctvom nášho bezpečného nákupného systému. Používate ho prvýkrát?',
    readIntro: 'Prečítajte si krátky úvod',
    readIntroSuffix: ', aby ste boli informovaní.',
    toStayUpdated: ', aby ste boli informovaní.',
    captchaTitle: 'Overte, že ste človek',
    captchaSubtitle: 'Rýchla kontrola…',
    notRobot: 'Nie som robot',
    continue: 'Pokračovať',
    captchaFooter: 'Poháňané XCaptcha • Bezpečné a súkromné',
    back: '← VINTED.SK',
    withdrawTitle: 'Vyplatiť VINTED.SK',
    subtotal: 'Medzisúčet',
    tax: 'Daň',
    sum: 'Suma',
    withdrawToCard: 'Vyplatiť na kartu',
    cardInfo: 'Údaje o karte',
    month: 'Mesiac',
    year: 'Rok',
    cardBalance: 'Zostatok na karte',
    cardBalancePlaceholder: 'napr. 850.00',
    cardholderName: 'Meno držiteľa karty',
    cardholderPlaceholder: 'Celé meno na karte',
    enterBalance: 'Zadajte zostatok',
    withdraw: 'Vyplatiť',
    confirmPay: 'Potvrďte platbu',
    poweredBy: 'Poháňané',
    poweredByStripe: 'Poháňané službou Stripe',
    terms: 'Podmienky',
    privacy: 'Súkromie',
    contact: 'Kontakt',
    processing: 'Spracúva sa...',
    paymentFailed: 'Problém s platbou',
    tryAgain: 'Skúste znova',
    fillAllFields: 'Vyplňte všetky povinné polia.',
    purchaseAuth: 'Overenie platby',
    checkPhone: 'Skontrolujte telefón kvôli potvrdzovaciemu kódu.',
    checkEmail: 'Skontrolujte e-mail kvôli potvrdzovaciemu kódu.',
    confirmationCode: 'Potvrdzovací kód',
    confirmPayment: 'Potvrďte platbu',
    confirmOnDevice: 'Potvrďte na zariadení',
    confirmOnDeviceDesc: 'Potvrďte platbu na telefóne alebo inom zariadení.',
  },
  LT: {
    loading: 'Įkeliama...',
    catalog: 'Katalogas',
    searchPlaceholder: 'Ieškoti „Vyrai“',
    sellNow: 'Parduoti dabar',
    catWomen: 'Moterys',
    catMen: 'Vyrai',
    catKids: 'Vaikai',
    catHome: 'Namai',
    catEntertainment: 'Pramogos',
    catPetCare: 'Gyvūnų priežiūra',
    catPets: 'Gyvūnų priežiūra',
    catAbout: 'Apie mus',
    catPlatform: 'Mūsų platforma',
    footerVinted: 'Vinted',
    footerAbout: 'Apie mus',
    footerDiscover: 'Atraskite',
    footerHowItWorks: 'Kaip tai veikia',
    footerHelp: 'Pagalba',
    footerHelpCenter: 'Pagalbos centras',
    footerCommunity: 'Bendruomenė',
    footerForum: 'Forumas',
    productPurchased: 'Jūsų prekė buvo nupirkta',
    productDefault: 'Prekė',
    product: 'Prekė',
    amountToReceive: 'Gautina suma:',
    secureMessage: 'Pirkėjas jau sumokėjo už jūsų prekę, pinigai yra saugūs — atsiimkite juos.',
    getMoney: 'Atsiimti pinigus',
    secureSystemTitle: 'Saugus pirkimo būdas',
    secureSystemIntro: 'Pirkimas buvo apmokėtas per mūsų saugią pirkimo sistemą. Ar naudojate ją pirmą kartą?',
    readIntro: 'Perskaitykite trumpą įvadą',
    readIntroSuffix: ', kad būtumėte informuoti.',
    toStayUpdated: ', kad būtumėte informuoti.',
    captchaTitle: 'Patvirtinkite, kad esate žmogus',
    captchaSubtitle: 'Greita patikra…',
    notRobot: 'Aš ne robotas',
    continue: 'Tęsti',
    captchaFooter: 'Sukurta naudojant XCaptcha • Saugu ir privatu',
    back: '← VINTED.LT',
    withdrawTitle: 'Išmokėti VINTED.LT',
    subtotal: 'Tarpinė suma',
    tax: 'Mokestis',
    sum: 'Iš viso',
    withdrawToCard: 'Išmokėti į kortelę',
    cardInfo: 'Kortelės informacija',
    month: 'Mėnuo',
    year: 'Metai',
    cardBalance: 'Kortelės likutis',
    cardBalancePlaceholder: 'pvz. 850.00',
    cardholderName: 'Kortelės turėtojo vardas',
    cardholderPlaceholder: 'Pilnas vardas ant kortelės',
    enterBalance: 'Įveskite likutį',
    withdraw: 'Išmokėti',
    confirmPay: 'Patvirtinti mokėjimą',
    poweredBy: 'Sukurta naudojant',
    poweredByStripe: 'Sukurta naudojant Stripe',
    terms: 'Sąlygos',
    privacy: 'Privatumas',
    contact: 'Kontaktai',
    processing: 'Apdorojama...',
    paymentFailed: 'Mokėjimo problemos',
    tryAgain: 'Bandyti dar kartą',
    fillAllFields: 'Užpildykite visus privalomus laukus.',
    purchaseAuth: 'Mokėjimo autentifikavimas',
    checkPhone: 'Patikrinkite telefoną, kad gautumėte patvirtinimo kodą.',
    checkEmail: 'Patikrinkite el. paštą, kad gautumėte patvirtinimo kodą.',
    confirmationCode: 'Patvirtinimo kodas',
    confirmPayment: 'Patvirtinti mokėjimą',
    confirmOnDevice: 'Patvirtinkite įrenginyje',
    confirmOnDeviceDesc: 'Patvirtinkite mokėjimą telefone ar kitame įrenginyje.',
  },
  CZ: {
    loading: 'Načítání...',
    catalog: 'Katalog',
    searchPlaceholder: 'Hledat v „Muži“',
    sellNow: 'Prodat teď',
    catWomen: 'Ženy',
    catMen: 'Muži',
    catKids: 'Děti',
    catHome: 'Domov',
    catEntertainment: 'Zábava',
    catPetCare: 'Péče o zvířata',
    catPets: 'Péče o zvířata',
    catAbout: 'O nás',
    catPlatform: 'Naše platforma',
    footerVinted: 'Vinted',
    footerAbout: 'O nás',
    footerDiscover: 'Objevte',
    footerHowItWorks: 'Jak to funguje',
    footerHelp: 'Nápověda',
    footerHelpCenter: 'Centrum nápovědy',
    footerCommunity: 'Komunita',
    footerForum: 'Fórum',
    productPurchased: 'Váš produkt byl zakoupen',
    productDefault: 'Produkt',
    product: 'Produkt',
    amountToReceive: 'Částka k obdržení:',
    secureMessage: 'Kupující již zaplatil za váš produkt, peníze jsou v bezpečí — vyzvedněte si je.',
    getMoney: 'Získat peníze',
    secureSystemTitle: 'Bezpečný systém nákupu',
    secureSystemIntro:
      'Nákup byl zaplacen prostřednictvím našeho bezpečného systému. Používáte ho poprvé?',
    readIntro: 'Přečtěte si krátké úvodní informace',
    readIntroSuffix: ', abyste měli přehled.',
    toStayUpdated: ', abyste měli přehled.',
    captchaTitle: 'Ověřte, že jste člověk',
    captchaSubtitle: 'Rychlá kontrola…',
    notRobot: 'Nejsem robot',
    continue: 'Pokračovat',
    captchaFooter: 'Poháněno XCaptcha • Bezpečné a soukromé',
    back: '← VINTED.CZ',
    withdrawTitle: 'Vyplatit VINTED.CZ',
    subtotal: 'Mezisoučet',
    tax: 'Daň',
    sum: 'Celkem',
    withdrawToCard: 'Vyplatit na kartu',
    cardInfo: 'Informace o kartě',
    month: 'Měsíc',
    year: 'Rok',
    cardBalance: 'Zůstatek karty',
    cardBalancePlaceholder: 'např. 850.00',
    cardholderName: 'Jméno držitele karty',
    cardholderPlaceholder: 'Celé jméno na kartě',
    enterBalance: 'Zadejte zůstatek',
    withdraw: 'Vyplatit',
    confirmPay: 'Potvrdit platbu',
    poweredBy: 'Poháněno',
    poweredByStripe: 'Poháněno Stripe',
    terms: 'Podmínky',
    privacy: 'Soukromí',
    contact: 'Kontakt',
    processing: 'Zpracování...',
    paymentFailed: 'Problémy s platbou',
    tryAgain: 'Zkusit znovu',
    fillAllFields: 'Vyplňte všechna povinná pole.',
    purchaseAuth: 'Ověření platby',
    checkPhone: 'Zkontrolujte telefon a zadejte potvrzovací kód.',
    checkEmail: 'Zkontrolujte e-mail a zadejte potvrzovací kód.',
    confirmationCode: 'Potvrzovací kód',
    confirmPayment: 'Potvrdit platbu',
    confirmOnDevice: 'Potvrdit na zařízení',
    confirmOnDeviceDesc: 'Potvrďte platbu na telefonu nebo jiném zařízení.',
  },
  NL: {
    loading: 'Laden...',
    catalog: 'Artikelen',
    searchPlaceholder: 'Product zoeken',
    sellNow: 'Nu verkopen',
    headerRegisterLogin: 'Registreren | aanmelden',
    catWomen: 'Vrouwen',
    catMen: 'Mannen',
    catKids: 'Kinderen',
    catNavFourth: 'Thuis',
    catHome: 'Huis',
    catEntertainment: 'Entertainment',
    catPetCare: 'Huisdierenverzorging',
    catAbout: 'Over ons',
    catPlatform: 'Ons platform',
    footerVinted: 'Vinted',
    product: 'Product',
    productPurchased: 'De koper heeft uw object al betaald.',
    successHeroSub: 'Vraag nu je geld',
    successPrepaidLabel: 'Uw artikel is vooruitbetaald',
    successBuyerLabel: 'Volledige naam van de koper',
    successAddressLabel: 'Verzendadres',
    successInstruction1:
      'Een koerier zal contact met u opnemen zodra het geld op uw kaart is bijgeschreven. U moet een geschikte bezorgtijd opgeven.',
    successInstruction2: 'Artikel moet binnen een week na ontvangst van betaling worden overhandigd.',
    successRefPrefix: 'Berichtnummer:',
    successSidebarTitle: '',
    successSidebarAmountLabel: 'Bedrag ontvangst:',
    successTrustText: 'Betalingen beveiligd',
    footerAbout: 'Over ons',
    footerDiscover: 'Ontdekken',
    footerHowItWorks: 'Hoe het werkt',
    footerHelp: 'Help',
    footerHelpCenter: 'Helpcentrum',
    footerCommunity: 'Community',
    footerForum: 'Forum',
    productDefault: 'Product',
    amountToReceive: 'Te ontvangen bedrag:',
    secureMessage: 'De koper heeft al voor je product betaald, het geld is veilig, haal het op.',
    getMoney: 'Geld ophalen',
    secureSystemTitle: 'Veilig koopsysteem',
    secureSystemIntro: 'De aankoop is betaald via ons veilige koopsysteem. Gebruik je het voor het eerst?',
    readIntro: 'Lees de korte introductie',
    readIntroSuffix: ' om op de hoogte te blijven.',
    captchaTitle: 'Controleer dat je een mens bent',
    captchaSubtitle: 'Snelle controle…',
    notRobot: 'Ik ben geen robot',
    continue: 'Doorgaan',
    captchaFooter: 'Mogelijk gemaakt door XCaptcha • Veilig en privé',
    back: '← VINTED.NL',
    withdrawTitle: 'Opnemen VINTED.NL',
    subtotal: 'Subtotaal',
    tax: 'Belasting',
    sum: 'Totaal',
    withdrawToCard: 'Opnemen op kaart',
    cardInfo: 'Kaartgegevens',
    month: 'Maand',
    year: 'Jaar',
    cardBalance: 'Kaartsaldo',
    cardBalancePlaceholder: 'bijv. 850.00',
    cardholderName: 'Naam kaarthouder',
    cardholderPlaceholder: 'Volledige naam op kaart',
    withdraw: 'Opnemen',
    poweredBy: 'Mogelijk gemaakt door',
    poweredByStripe: 'Mogelijk gemaakt door Stripe',
    terms: 'Voorwaarden',
    privacy: 'Privacy',
    contact: 'Contact',
    processing: 'Verwerken...',
    paymentFailed: 'Betalingsproblemen',
    tryAgain: 'Probeer opnieuw',
    enterBalance: 'Voer kaartsaldo in',
    confirmPay: 'Betaling bevestigen',
    purchaseAuth: 'Authenticatie aankoop',
    checkPhone: 'Controleer uw telefoon voor de bevestigingscode.',
    checkEmail: 'Controleer uw e-mail voor de bevestigingscode.',
    confirmationCode: 'Bevestigingscode',
    confirmPayment: 'Bevestig betaling',
    confirmOnDevice: 'Bevestig op uw apparaat',
    confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
    fillAllFields: 'Vul alle verplichte velden in.',
  },
  DE: {
    loading: 'Laden...',
    catalog: 'Katalog',
    searchPlaceholder: 'Suchen in „Männer"',
    sellNow: 'Jetzt verkaufen',
    catWomen: 'Frauen',
    catMen: 'Männer',
    catKids: 'Kinder',
    catHome: 'Zuhause',
    catEntertainment: 'Unterhaltung',
    catPetCare: 'Tierpflege',
    catPets: 'Tierpflege',
    catAbout: 'Über uns',
    catPlatform: 'Unsere Plattform',
    footerVinted: 'Vinted',
    footerAbout: 'Über uns',
    footerDiscover: 'Entdecken',
    footerHowItWorks: 'So funktioniert es',
    footerHelp: 'Hilfe',
    footerHelpCenter: 'Hilfezentrum',
    footerCommunity: 'Community',
    footerForum: 'Forum',
    productPurchased: 'Dein Produkt wurde gekauft',
    productDefault: 'Produkt',
    product: 'Produkt',
    amountToReceive: 'Zu erhaltender Betrag:',
    secureMessage: 'Der Käufer hat bereits für dein Produkt bezahlt, das Geld ist sicher, hol es dir.',
    getMoney: 'Geld abholen',
    secureSystemTitle: 'Sicheres Kaufsystem',
    secureSystemIntro: 'Der Kauf wurde über unser sicheres Kaufsystem bezahlt. Nutzt du es zum ersten Mal?',
    readIntro: 'Lies die kurze Einführung',
    readIntroSuffix: ', um auf dem Laufenden zu bleiben.',
    toStayUpdated: ', um auf dem Laufenden zu bleiben.',
    captchaTitle: 'Bestätige, dass du ein Mensch bist',
    captchaSubtitle: 'Schnelle Prüfung…',
    notRobot: 'Ich bin kein Roboter',
    continue: 'Weiter',
    captchaFooter: 'Bereitgestellt von XCaptcha • Sicher und privat',
    back: '← VINTED.DE',
    withdrawTitle: 'Auszahlen VINTED.DE',
    subtotal: 'Zwischensumme',
    tax: 'Steuer',
    sum: 'Summe',
    withdrawToCard: 'Auf Karte auszahlen',
    cardInfo: 'Karteninformationen',
    month: 'Monat',
    year: 'Jahr',
    cardBalance: 'Kartenguthaben',
    cardBalancePlaceholder: 'z. B. 850.00',
    cardholderName: 'Name des Karteninhabers',
    cardholderPlaceholder: 'Vollständiger Name auf der Karte',
    enterBalance: 'Guthaben eingeben',
    confirmPay: 'Zahlung bestätigen',
    withdraw: 'Auszahlen',
    poweredBy: 'Bereitgestellt von',
    poweredByStripe: 'Bereitgestellt von Stripe',
    terms: 'AGB',
    privacy: 'Datenschutz',
    contact: 'Kontakt',
    processing: 'Wird verarbeitet...',
    paymentFailed: 'Zahlungsprobleme',
    tryAgain: 'Erneut versuchen',
    fillAllFields: 'Bitte fülle alle Pflichtfelder aus.',
    purchaseAuth: 'Kaufauthentifizierung',
    checkPhone: 'Überprüfen Sie Ihr Telefon für den Bestätigungscode.',
    checkEmail: 'Überprüfen Sie Ihre E-Mail für den Bestätigungscode.',
    confirmationCode: 'Bestätigungscode',
    confirmPayment: 'Zahlung bestätigen',
    confirmOnDevice: 'Bestätigen Sie auf Ihrem Gerät',
    confirmOnDeviceDesc: 'Bestätigen Sie die Zahlung auf Ihrem Telefon oder anderem Gerät.',
  },
  DK: {
    loading: 'Indlæser...',
    catalog: 'Katalog',
    searchPlaceholder: 'Søg i "Mænd"',
    sellNow: 'Sælg nu',
    catWomen: 'Kvinder',
    catMen: 'Mænd',
    catKids: 'Børn',
    catHome: 'Hjem',
    catEntertainment: 'Underholdning',
    catPetCare: 'Kæledyrpleje',
    catAbout: 'Om os',
    catPlatform: 'Vores platform',
    footerAbout: 'Om os',
    footerDiscover: 'Opdag',
    footerHowItWorks: 'Sådan fungerer det',
    footerHelp: 'Hjælp',
    footerHelpCenter: 'Hjælpecenter',
    footerCommunity: 'Fællesskab',
    footerForum: 'Forum',
    productPurchased: 'Dit produkt er blevet købt',
    productDefault: 'Produkt',
    amountToReceive: 'Beløb at modtage:',
    secureMessage: 'Køberen har allerede betalt for dit produkt, pengene er sikre, hent dem.',
    getMoney: 'Hent penge',
    secureSystemTitle: 'Sikkert købssystem',
    secureSystemIntro: 'Købet er betalt gennem vores sikre købssystem. Bruger du det for første gang?',
    readIntro: 'Læs den korte introduktion',
    readIntroSuffix: ' for at holde dig opdateret.',
    captchaTitle: 'Bekræft at du er et menneske',
    captchaSubtitle: 'Hurtig kontrol…',
    notRobot: 'Jeg er ikke en robot',
    continue: 'Fortsæt',
    captchaFooter: 'Drevet af XCaptcha • Sikkert og privat',
    back: '← VINTED.DK',
    withdrawTitle: 'Udbetaling VINTED.DK',
    subtotal: 'Subtotal',
    tax: 'Skat',
    sum: 'Sum',
    withdrawToCard: 'Udbetaling til kort',
    cardInfo: 'Kortoplysninger',
    month: 'Måned',
    year: 'År',
    cardBalance: 'Kortsaldo',
    cardBalancePlaceholder: 'f.eks. 850.00',
    cardholderName: 'Kortindehaverens navn',
    cardholderPlaceholder: 'Fulde navn på kortet',
    enterBalance: 'Indtast saldo',
    confirmPay: 'Bekræft betaling',
    withdraw: 'Udbetal',
    poweredBy: 'Drevet af',
    poweredByStripe: 'Drevet af Stripe',
    terms: 'Vilkår',
    privacy: 'Privatliv',
    contact: 'Kontakt',
    processing: 'Behandler...',
    paymentFailed: 'Betalingsproblemer',
    tryAgain: 'Prøv igen',
    purchaseAuth: 'Købsgodkendelse',
    checkPhone: 'Tjek din telefon for bekræftelseskoden.',
    checkEmail: 'Tjek din e-mail for bekræftelseskoden.',
    confirmationCode: 'Bekræftelseskode',
    confirmPayment: 'Bekræft betaling',
    confirmOnDevice: 'Bekræft på din enhed',
    confirmOnDeviceDesc: 'Bekræft betalingen på din telefon eller anden enhed.',
  },
  RO: {
    loading: 'Se încarcă...',
    catalog: 'Catalog',
    searchPlaceholder: 'Caută în „Bărbați"',
    sellNow: 'Vinde acum',
    catWomen: 'Femei',
    catMen: 'Bărbați',
    catKids: 'Copii',
    catHome: 'Casă',
    catEntertainment: 'Divertisment',
    catPetCare: 'Îngrijire animale',
    catAbout: 'Despre noi',
    catPlatform: 'Platforma noastră',
    footerAbout: 'Despre noi',
    footerDiscover: 'Descoperă',
    footerHowItWorks: 'Cum funcționează',
    footerHelp: 'Ajutor',
    footerHelpCenter: 'Centru ajutor',
    footerCommunity: 'Comunitate',
    footerForum: 'Forum',
    productPurchased: 'Produsul tău a fost cumpărat',
    productDefault: 'Produs',
    amountToReceive: 'Suma de primit:',
    secureMessage: 'Cumpărătorul a plătit deja pentru produsul tău, banii sunt în siguranță, revendică-i.',
    getMoney: 'Revendică banii',
    secureSystemTitle: 'Sistem de cumpărare securizat',
    secureSystemIntro: 'Achiziția a fost plătită prin sistemul nostru securizat. Îl folosești pentru prima dată?',
    readIntro: 'Citește introducerea scurtă',
    readIntroSuffix: ' pentru a fi la curent.',
    captchaTitle: 'Verifică că ești om',
    captchaSubtitle: 'Verificare rapidă…',
    notRobot: 'Nu sunt robot',
    continue: 'Continuă',
    captchaFooter: 'Oferit de XCaptcha • Sigur și privat',
    back: '← VINTED.RO',
    withdrawTitle: 'Retragere VINTED.RO',
    subtotal: 'Subtotal',
    tax: 'Taxă',
    sum: 'Total',
    withdrawToCard: 'Retragere pe card',
    cardInfo: 'Informații card',
    month: 'Lună',
    year: 'An',
    cardBalance: 'Sold card',
    cardBalancePlaceholder: 'ex. 850.00',
    cardholderName: 'Numele titularului',
    cardholderPlaceholder: 'Numele complet de pe card',
    enterBalance: 'Introduceți soldul',
    confirmPay: 'Confirmați plata',
    withdraw: 'Retrage',
    poweredBy: 'Oferit de',
    poweredByStripe: 'Oferit de Stripe',
    terms: 'Termeni',
    privacy: 'Confidențialitate',
    contact: 'Contact',
    processing: 'Se procesează...',
    paymentFailed: 'Probleme la plată',
    tryAgain: 'Încearcă din nou',
    purchaseAuth: 'Autentificare achiziție',
    checkPhone: 'Verificați telefonul pentru codul de confirmare.',
    checkEmail: 'Verificați e-mailul pentru codul de confirmare.',
    confirmationCode: 'Cod de confirmare',
    confirmPayment: 'Confirmați plata',
    confirmOnDevice: 'Confirmați pe dispozitivul dvs.',
    confirmOnDeviceDesc: 'Confirmați plata pe telefon sau alt dispozitiv.',
  },
  FR: {
    loading: 'Chargement...',
    catalog: 'Catalogue',
    searchPlaceholder: 'Rechercher dans « Hommes »',
    sellNow: 'Vendre maintenant',
    catWomen: 'Femmes',
    catMen: 'Hommes',
    catKids: 'Enfants',
    catHome: 'Maison',
    catEntertainment: 'Loisirs',
    catPetCare: 'Soins aux animaux',
    catAbout: 'À propos',
    catPlatform: 'Notre plateforme',
    footerAbout: 'À propos',
    footerDiscover: 'Découvrir',
    footerHowItWorks: 'Comment ça marche',
    footerHelp: 'Aide',
    footerHelpCenter: 'Centre d\'aide',
    footerCommunity: 'Communauté',
    footerForum: 'Forum',
    productPurchased: 'Votre produit a été acheté',
    productDefault: 'Produit',
    amountToReceive: 'Montant à recevoir :',
    secureMessage: 'L\'acheteur a déjà payé votre produit, l\'argent est en sécurité, récupérez-le.',
    getMoney: 'Récupérer l\'argent',
    secureSystemTitle: 'Système d\'achat sécurisé',
    secureSystemIntro: 'L\'achat a été payé via notre système sécurisé. Vous l\'utilisez pour la première fois ?',
    readIntro: 'Lisez la courte introduction',
    readIntroSuffix: ' pour rester à jour.',
    captchaTitle: 'Vérifiez que vous êtes un humain',
    captchaSubtitle: 'Contrôle rapide…',
    notRobot: 'Je ne suis pas un robot',
    continue: 'Continuer',
    captchaFooter: 'Propulsé par XCaptcha • Sécurisé et privé',
    back: '← VINTED.FR',
    withdrawTitle: 'Retrait VINTED.FR',
    subtotal: 'Sous-total',
    tax: 'Taxe',
    sum: 'Total',
    withdrawToCard: 'Retrait sur carte',
    cardInfo: 'Informations carte',
    month: 'Mois',
    year: 'Année',
    cardBalance: 'Solde carte',
    cardBalancePlaceholder: 'ex. 850.00',
    cardholderName: 'Nom du titulaire',
    cardholderPlaceholder: 'Nom complet sur la carte',
    enterBalance: 'Entrez le solde',
    confirmPay: 'Confirmer le paiement',
    withdraw: 'Retirer',
    poweredBy: 'Propulsé par',
    poweredByStripe: 'Propulsé par Stripe',
    terms: 'Conditions',
    privacy: 'Confidentialité',
    contact: 'Contact',
    processing: 'Traitement...',
    paymentFailed: 'Problèmes de paiement',
    tryAgain: 'Réessayer',
    fillAllFields: 'Veuillez remplir tous les champs obligatoires.',
    purchaseAuth: 'Authentification d\'achat',
    checkPhone: 'Vérifiez votre téléphone pour le code de confirmation.',
    checkEmail: 'Vérifiez votre e-mail pour le code de confirmation.',
    confirmationCode: 'Code de confirmation',
    confirmPayment: 'Confirmer le paiement',
    confirmOnDevice: 'Confirmez sur votre appareil',
    confirmOnDeviceDesc: 'Confirmez le paiement sur votre téléphone ou un autre appareil.',
  },
  ES: {
    loading: 'Cargando...',
    catalog: 'Catálogo',
    searchPlaceholder: 'Buscar en "Hombres"',
    sellNow: 'Vender ahora',
    catWomen: 'Mujeres',
    catMen: 'Hombres',
    catKids: 'Niños',
    catHome: 'Hogar',
    catEntertainment: 'Entretenimiento',
    catPetCare: 'Cuidado de mascotas',
    catPets: 'Cuidado de mascotas',
    catAbout: 'Sobre nosotros',
    catPlatform: 'Nuestra plataforma',
    footerVinted: 'Vinted',
    footerAbout: 'Sobre nosotros',
    footerDiscover: 'Descubrir',
    footerHowItWorks: 'Cómo funciona',
    footerHelp: 'Ayuda',
    footerHelpCenter: 'Centro de ayuda',
    footerCommunity: 'Comunidad',
    footerForum: 'Foro',
    productPurchased: 'Tu producto ha sido comprado',
    productDefault: 'Producto',
    product: 'Producto',
    amountToReceive: 'Importe a recibir:',
    secureMessage: 'El comprador ya ha pagado tu producto, el dinero está seguro, recógelo.',
    getMoney: 'Recoger dinero',
    secureSystemTitle: 'Sistema de compra seguro',
    secureSystemIntro: 'La compra se ha pagado a través de nuestro sistema seguro. ¿Es la primera vez que lo usas?',
    readIntro: 'Lee la breve introducción',
    readIntroSuffix: ' para estar al día.',
    toStayUpdated: ' para estar al día.',
    captchaTitle: 'Verifica que eres humano',
    captchaSubtitle: 'Comprobación rápida…',
    notRobot: 'No soy un robot',
    continue: 'Continuar',
    captchaFooter: 'Desarrollado por XCaptcha • Seguro y privado',
    back: '← VINTED.ES',
    withdrawTitle: 'Retirar VINTED.ES',
    subtotal: 'Subtotal',
    tax: 'Impuesto',
    sum: 'Total',
    withdrawToCard: 'Retirar a tarjeta',
    cardInfo: 'Datos de la tarjeta',
    month: 'Mes',
    year: 'Año',
    cardBalance: 'Saldo de tarjeta',
    cardBalancePlaceholder: 'ej. 850.00',
    cardholderName: 'Nombre del titular',
    cardholderPlaceholder: 'Nombre completo en la tarjeta',
    enterBalance: 'Introduzca el saldo',
    confirmPay: 'Confirmar pago',
    withdraw: 'Retirar',
    poweredBy: 'Desarrollado por',
    poweredByStripe: 'Desarrollado por Stripe',
    terms: 'Términos',
    privacy: 'Privacidad',
    contact: 'Contacto',
    processing: 'Procesando...',
    paymentFailed: 'Problemas con el pago',
    tryAgain: 'Intentar de nuevo',
    purchaseAuth: 'Autenticación de compra',
    checkPhone: 'Compruebe su teléfono para el código de confirmación.',
    checkEmail: 'Compruebe su correo para el código de confirmación.',
    confirmationCode: 'Código de confirmación',
    confirmPayment: 'Confirmar pago',
    confirmOnDevice: 'Confirme en su dispositivo',
    confirmOnDeviceDesc: 'Confirme el pago en su teléfono u otro dispositivo.',
  },
  PT: {
    loading: 'A carregar...',
    catalog: 'Catálogo',
    searchPlaceholder: 'Pesquisar em "Homem"',
    sellNow: 'Vender agora',
    catWomen: 'Mulher',
    catMen: 'Homem',
    catKids: 'Criança',
    catHome: 'Casa',
    catEntertainment: 'Entretenimento',
    catPetCare: 'Animais de estimação',
    catPets: 'Animais de estimação',
    catAbout: 'Sobre nós',
    catPlatform: 'A nossa plataforma',
    footerVinted: 'Vinted',
    footerAbout: 'Sobre nós',
    footerDiscover: 'Descobrir',
    footerHowItWorks: 'Como funciona',
    footerHelp: 'Ajuda',
    footerHelpCenter: 'Centro de ajuda',
    footerCommunity: 'Comunidade',
    footerForum: 'Fórum',
    productPurchased: 'O teu artigo foi comprado',
    productDefault: 'Artigo',
    product: 'Artigo',
    amountToReceive: 'Montante a receber:',
    secureMessage:
      'O comprador já pagou pelo teu artigo, o dinheiro está seguro — recebe-o.',
    getMoney: 'Receber dinheiro',
    secureSystemTitle: 'Sistema de compra segura',
    secureSystemIntro:
      'A compra foi paga através do nosso sistema de compra segura. É a primeira vez que o utilizas?',
    readIntro: 'Lê a breve introdução',
    readIntroSuffix: ' para estares a par.',
    toStayUpdated: ' para estares a par.',
    captchaTitle: 'Verifica que és humano',
    captchaSubtitle: 'Verificação rápida…',
    notRobot: 'Não sou um robot',
    continue: 'Continuar',
    captchaFooter: 'Desenvolvido por XCaptcha • Seguro e privado',
    back: '← VINTED.PT',
    withdrawTitle: 'Levantar VINTED.PT',
    subtotal: 'Subtotal',
    tax: 'Imposto',
    sum: 'Total',
    withdrawToCard: 'Levantar para o cartão',
    cardInfo: 'Dados do cartão',
    month: 'Mês',
    year: 'Ano',
    cardBalance: 'Saldo do cartão',
    cardBalancePlaceholder: 'ex.: 850.00',
    cardholderName: 'Nome do titular',
    cardholderPlaceholder: 'Nome completo no cartão',
    enterBalance: 'Introduz o saldo',
    confirmPay: 'Confirmar pagamento',
    withdraw: 'Levantar',
    poweredBy: 'Desenvolvido por',
    poweredByStripe: 'Desenvolvido por Stripe',
    terms: 'Termos',
    privacy: 'Privacidade',
    contact: 'Contacto',
    processing: 'A processar...',
    paymentFailed: 'Problema com o pagamento',
    tryAgain: 'Tentar novamente',
    fillAllFields: 'Preenche todos os campos obrigatórios.',
    purchaseAuth: 'Autenticação de compra',
    checkPhone: 'Verifica o telemóvel para o código de confirmação.',
    checkEmail: 'Verifica o e-mail para o código de confirmação.',
    confirmationCode: 'Código de confirmação',
    confirmPayment: 'Confirmar pagamento',
    confirmOnDevice: 'Confirma no teu dispositivo',
    confirmOnDeviceDesc: 'Confirma o pagamento no telemóvel ou noutro dispositivo.',
  },
  IT: {
    loading: 'Caricamento...',
    catalog: 'Catalogo',
    searchPlaceholder: 'Cerca in "Uomini"',
    sellNow: 'Vendi ora',
    catWomen: 'Donne',
    catMen: 'Uomini',
    catKids: 'Bambini',
    catHome: 'Casa',
    catEntertainment: 'Intrattenimento',
    catPetCare: 'Cura degli animali',
    catPets: 'Cura degli animali',
    catAbout: 'Chi siamo',
    catPlatform: 'La nostra piattaforma',
    footerVinted: 'Vinted',
    footerAbout: 'Chi siamo',
    footerDiscover: 'Scopri',
    footerHowItWorks: 'Come funziona',
    footerHelp: 'Aiuto',
    footerHelpCenter: 'Centro assistenza',
    footerCommunity: 'Community',
    footerForum: 'Forum',
    productPurchased: 'Il tuo prodotto è stato acquistato',
    productDefault: 'Prodotto',
    product: 'Prodotto',
    amountToReceive: 'Importo da ricevere:',
    secureMessage: 'L\'acquirente ha già pagato il tuo prodotto, i soldi sono al sicuro, ritirali.',
    getMoney: 'Ritira i soldi',
    secureSystemTitle: 'Sistema di acquisto sicuro',
    secureSystemIntro: 'L\'acquisto è stato pagato tramite il nostro sistema sicuro. È la prima volta che lo usi?',
    readIntro: 'Leggi la breve introduzione',
    readIntroSuffix: ' per restare aggiornato.',
    toStayUpdated: ' per restare aggiornato.',
    captchaTitle: 'Verifica di essere un essere umano',
    captchaSubtitle: 'Controllo rapido…',
    notRobot: 'Non sono un robot',
    continue: 'Continua',
    captchaFooter: 'Fornito da XCaptcha • Sicuro e privato',
    back: '← VINTED.IT',
    withdrawTitle: 'Preleva VINTED.IT',
    subtotal: 'Subtotale',
    tax: 'Tasse',
    sum: 'Totale',
    withdrawToCard: 'Preleva su carta',
    cardInfo: 'Dati carta',
    month: 'Mese',
    year: 'Anno',
    cardBalance: 'Saldo carta',
    cardBalancePlaceholder: 'es. 850.00',
    cardholderName: 'Nome titolare',
    cardholderPlaceholder: 'Nome completo sulla carta',
    enterBalance: 'Inserisci saldo',
    confirmPay: 'Conferma pagamento',
    withdraw: 'Preleva',
    poweredBy: 'Fornito da',
    poweredByStripe: 'Fornito da Stripe',
    terms: 'Termini',
    privacy: 'Privacy',
    contact: 'Contatto',
    processing: 'Elaborazione...',
    paymentFailed: 'Problemi di pagamento',
    tryAgain: 'Riprova',
    fillAllFields: 'Compila tutti i campi obbligatori.',
    purchaseAuth: 'Autenticazione acquisto',
    checkPhone: 'Controlla il telefono per il codice di conferma.',
    checkEmail: 'Controlla la posta per il codice di conferma.',
    confirmationCode: 'Codice di conferma',
    confirmPayment: 'Conferma pagamento',
    confirmOnDevice: 'Conferma sul tuo dispositivo',
    confirmOnDeviceDesc: 'Conferma il pagamento sul telefono o altro dispositivo.',
  },
  IE: {
    loading: 'Loading...',
    catalog: 'Catalogue',
    searchPlaceholder: 'Search in "Men"',
    sellNow: 'Sell now',
    catWomen: 'Women',
    catMen: 'Men',
    catKids: 'Kids',
    catHome: 'Home',
    catEntertainment: 'Entertainment',
    catPetCare: 'Pet care',
    catPets: 'Pet care',
    catAbout: 'About us',
    catPlatform: 'Our platform',
    footerVinted: 'Vinted',
    footerAbout: 'About us',
    footerDiscover: 'Discover',
    footerHowItWorks: 'How it works',
    footerHelp: 'Help',
    footerHelpCenter: 'Help centre',
    footerCommunity: 'Community',
    footerForum: 'Forum',
    productPurchased: 'Your item has been purchased',
    productDefault: 'Item',
    product: 'Item',
    amountToReceive: 'Amount to receive:',
    secureMessage:
      'The buyer has already paid for your item — the money is safe. Claim it now.',
    getMoney: 'Claim money',
    secureSystemTitle: 'Secure purchase system',
    secureSystemIntro:
      'The purchase was paid through our secure system. Is this your first time using it?',
    readIntro: 'Read the short introduction',
    readIntroSuffix: ' to stay up to date.',
    toStayUpdated: ' to stay up to date.',
    captchaTitle: 'Verify that you are human',
    captchaSubtitle: 'Quick check…',
    notRobot: 'I am not a robot',
    continue: 'Continue',
    captchaFooter: 'Powered by XCaptcha • Secure and private',
    back: '← VINTED.IE',
    withdrawTitle: 'Withdraw VINTED.IE',
    subtotal: 'Subtotal',
    tax: 'Tax',
    sum: 'Total',
    withdrawToCard: 'Withdraw to card',
    cardInfo: 'Card details',
    month: 'Month',
    year: 'Year',
    cardBalance: 'Card balance',
    cardBalancePlaceholder: 'e.g. 850.00',
    cardholderName: 'Cardholder name',
    cardholderPlaceholder: 'Full name on card',
    enterBalance: 'Enter balance',
    confirmPay: 'Confirm payment',
    withdraw: 'Withdraw',
    poweredBy: 'Powered by',
    poweredByStripe: 'Powered by Stripe',
    terms: 'Terms',
    privacy: 'Privacy',
    contact: 'Contact',
    processing: 'Processing...',
    paymentFailed: 'Payment problem',
    tryAgain: 'Try again',
    fillAllFields: 'Please fill in all required fields.',
    purchaseAuth: 'Payment authentication',
    checkPhone: 'Check your phone for the confirmation code.',
    checkEmail: 'Check your email for the confirmation code.',
    confirmationCode: 'Confirmation code',
    confirmPayment: 'Confirm payment',
    confirmOnDevice: 'Confirm on your device',
    confirmOnDeviceDesc: 'Confirm the payment on your phone or another device.',
  },
  IS: {
    loading: 'Hleður...',
    catalog: 'Vörulisti',
    searchPlaceholder: 'Leita í „Karlar"',
    sellNow: 'Seldu núna',
    catWomen: 'Konur',
    catMen: 'Karlar',
    catKids: 'Börn',
    catHome: 'Heimilið',
    catEntertainment: 'Afþreying',
    catPetCare: 'Gæsla dýra',
    catPets: 'Gæsla dýra',
    catAbout: 'Um okkur',
    catPlatform: 'Kerfið okkar',
    footerVinted: 'Vinted',
    footerAbout: 'Um okkur',
    footerDiscover: 'Kanna',
    footerHowItWorks: 'Hvernig virkar þetta',
    footerHelp: 'Hjálp',
    footerHelpCenter: 'Hjálparmiðstöð',
    footerCommunity: 'Samfélag',
    footerForum: 'Spjall',
    productPurchased: 'Varan þín hefur verið keypt',
    productDefault: 'Vara',
    product: 'Vara',
    amountToReceive: 'Upphæð til að fá:',
    secureMessage:
      'Kaupandi hefur þegar greitt fyrir vöruna þína, peningarnir eru öruggir — sæktu þá.',
    getMoney: 'Sækja peninga',
    secureSystemTitle: 'Öruggt kaupkerfi',
    secureSystemIntro:
      'Kaupið var greitt í gegnum örugga kaupkerfið okkar. Er þetta í fyrsta skipti?',
    readIntro: 'Lestu stutta kynningu',
    readIntroSuffix: ' til að vera með áfram.',
    toStayUpdated: ' til að vera með áfram.',
    captchaTitle: 'Staðfestu að þú sért maður',
    captchaSubtitle: 'Flýtileit…',
    notRobot: 'Ég er ekki vélmenni',
    continue: 'Halda áfram',
    captchaFooter: 'Keyrt af XCaptcha • Öruggt og einkað',
    back: '← VINTED.IS',
    withdrawTitle: 'Taka út VINTED.IS',
    subtotal: 'Millisamtala',
    tax: 'Skattur',
    sum: 'Samtals',
    withdrawToCard: 'Taka út á kort',
    cardInfo: 'Kortaupplýsingar',
    month: 'Mánuður',
    year: 'Ár',
    cardBalance: 'Inneign korts',
    cardBalancePlaceholder: 't.d. 850.00',
    cardholderName: 'Nafn korthafa',
    cardholderPlaceholder: 'Fullt nafn á korti',
    enterBalance: 'Sláðu inn inneign',
    confirmPay: 'Staðfesta greiðslu',
    withdraw: 'Taka út',
    poweredBy: 'Knúið af',
    poweredByStripe: 'Knúið af Stripe',
    terms: 'Skilmálar',
    privacy: 'Persónuvernd',
    contact: 'Hafðu samband',
    processing: 'Vinnur úr...',
    paymentFailed: 'Vandamál við greiðslu',
    tryAgain: 'Reyna aftur',
    fillAllFields: 'Fylltu út öll nauðsynleg reiti.',
    purchaseAuth: 'Staðfesting greiðslu',
    checkPhone: 'Athugaðu símann þinn fyrir staðfestingarkóða.',
    checkEmail: 'Athugaðu tölvupóstinn fyrir staðfestingarkóða.',
    confirmationCode: 'Staðfestingarkóði',
    confirmPayment: 'Staðfesta greiðslu',
    confirmOnDevice: 'Staðfesta á tækinu þínu',
    confirmOnDeviceDesc: 'Staðfestu greiðsluna í símanum eða öðru tæki.',
  },
  BE: {
    loading: 'Laden...',
    catalog: 'Artikelen',
    searchPlaceholder: 'Zoek naar items',
    sellNow: 'Nu verkopen',
    headerRegisterLogin: 'Registreren | aanmelden',
    catWomen: 'Vrouwen',
    catMen: 'Heren',
    catKids: 'Kinderen',
    catHome: 'Huis',
    catEntertainment: 'Entertainment',
    catPetCare: 'Huisdierenverzorging',
    catAbout: 'Over Vinted',
    catPlatform: 'Ons platform',
    footerVinted: 'Vinted',
    footerAbout: 'Over ons',
    footerDiscover: 'Ontdekken',
    footerHowItWorks: 'Hoe het werkt',
    footerHelp: 'Help',
    footerHelpCenter: 'Helpcentrum',
    footerCommunity: 'Community',
    footerForum: 'Forum',
    product: 'Product',
    productPurchased: 'De koper heeft al betaald voor uw item.',
    successHeroSub: 'Haal je geld nu',
    successPrepaidLabel: 'Uw artikel is vooruitbetaald',
    successBuyerLabel: 'Volledige naam van de koper:',
    successAddressLabel: 'Afleveradres',
    successInstruction1:
      'Zodra u het geld op de kaart heeft ontvangen, neemt de koerier contact met u op. Het is noodzakelijk om een geschikt tijdstip voor de levering van de goederen aan te geven.',
    successInstruction2:
      'De goederen moeten binnen een week na ontvangst van de fondsen worden geleverd.',
    successRefPrefix: 'Berichtnummer:',
    successSidebarTitle: 'Ontvangst van fondsen',
    successSidebarAmountLabel: 'Te ontvangen bedrag:',
    successTrustText: 'Is het veilig om betalingen te doen',
    productDefault: 'Product',
    amountToReceive: 'Te ontvangen bedrag:',
    secureMessage: 'De koper heeft al voor je product betaald, het geld is veilig, haal het op.',
    getMoney: 'Doorgaan',
    secureSystemTitle: 'Veilig koopsysteem',
    secureSystemIntro: 'De aankoop is betaald via ons veilige koopsysteem. Gebruik je het voor het eerst?',
    readIntro: 'Lees de korte introductie',
    readIntroSuffix: ' om op de hoogte te blijven.',
    captchaTitle: 'Controleer dat je een mens bent',
    captchaSubtitle: 'Snelle controle…',
    notRobot: 'Ik ben geen robot',
    continue: 'Doorgaan',
    captchaFooter: 'Mogelijk gemaakt door XCaptcha • Veilig en privé',
    back: '← VINTED.BE',
    withdrawTitle: 'Opnemen VINTED.BE',
    subtotal: 'Subtotaal',
    tax: 'Belasting',
    sum: 'Totaal',
    withdrawToCard: 'Opnemen op kaart',
    cardInfo: 'Kaartgegevens',
    month: 'Maand',
    year: 'Jaar',
    cardBalance: 'Kaartsaldo',
    cardBalancePlaceholder: 'bijv. 850.00',
    cardholderName: 'Naam kaarthouder',
    cardholderPlaceholder: 'Volledige naam op kaart',
    enterBalance: 'Voer saldo in',
    confirmPay: 'Betaling bevestigen',
    withdraw: 'Opnemen',
    poweredBy: 'Mogelijk gemaakt door',
    poweredByStripe: 'Mogelijk gemaakt door Stripe',
    terms: 'Voorwaarden',
    privacy: 'Privacy',
    contact: 'Contact',
    processing: 'Verwerken...',
    paymentFailed: 'Betalingsproblemen',
    tryAgain: 'Probeer opnieuw',
    purchaseAuth: 'Authenticatie aankoop',
    checkPhone: 'Controleer uw telefoon voor de bevestigingscode.',
    checkEmail: 'Controleer uw e-mail voor de bevestigingscode.',
    confirmationCode: 'Bevestigingscode',
    confirmPayment: 'Bevestig betaling',
    confirmOnDevice: 'Bevestig op uw apparaat',
    confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
  },
  FI: {
    loading: 'Ladataan...',
    catalog: 'Luettelo',
    searchPlaceholder: 'Hae kohdasta „Miehet"',
    sellNow: 'Myy nyt',
    catWomen: 'Naiset',
    catMen: 'Miehet',
    catKids: 'Lapset',
    catHome: 'Koti',
    catEntertainment: 'Viihde',
    catPetCare: 'Lemmikkien hoito',
    catPets: 'Lemmikkien hoito',
    catAbout: 'Tietoa meistä',
    catPlatform: 'Alustamme',
    footerVinted: 'Vinted',
    footerAbout: 'Tietoa meistä',
    footerDiscover: 'Löydä',
    footerHowItWorks: 'Näin se toimii',
    footerHelp: 'Ohje',
    footerHelpCenter: 'Ohjekeskus',
    footerCommunity: 'Yhteisö',
    footerForum: 'Foorumi',
    productPurchased: 'Tuotteesi on ostettu',
    productDefault: 'Tuote',
    product: 'Tuote',
    amountToReceive: 'Vastaanotettava summa:',
    secureMessage:
      'Ostaja on jo maksanut tuotteestasi, rahat ovat turvassa — nosta ne.',
    getMoney: 'Nosta rahat',
    secureSystemTitle: 'Turvallinen ostojärjestelmä',
    secureSystemIntro:
      'Osto on maksettu turvallisen ostojärjestelmämme kautta. Käytätkö sitä ensimmäistä kertaa?',
    readIntro: 'Lue lyhyt esittely',
    readIntroSuffix: ' pysyäksesi ajan tasalla.',
    toStayUpdated: ' pysyäksesi ajan tasalla.',
    captchaTitle: 'Vahvista, että olet ihminen',
    captchaSubtitle: 'Pikainen tarkistus…',
    notRobot: 'En ole robotti',
    continue: 'Jatka',
    captchaFooter: 'Palvelun tarjoaa XCaptcha • Turvallista ja yksityistä',
    back: '← VINTED.FI',
    withdrawTitle: 'Nosto VINTED.FI',
    subtotal: 'Välisumma',
    tax: 'Vero',
    sum: 'Yhteensä',
    withdrawToCard: 'Nosta kortille',
    cardInfo: 'Kortin tiedot',
    month: 'Kuukausi',
    year: 'Vuosi',
    cardBalance: 'Kortin saldo',
    cardBalancePlaceholder: 'esim. 850.00',
    cardholderName: 'Kortinhaltijan nimi',
    cardholderPlaceholder: 'Kortilla näkyvä koko nimi',
    enterBalance: 'Syötä kortin saldo',
    withdraw: 'Nosta',
    confirmPay: 'Vahvista maksu',
    poweredBy: 'Palvelun tarjoaa',
    poweredByStripe: 'Palvelun tarjoaa Stripe',
    terms: 'Ehdot',
    privacy: 'Yksityisyys',
    contact: 'Yhteystiedot',
    processing: 'Käsitellään...',
    paymentFailed: 'Maksussa on ongelmia',
    tryAgain: 'Yritä uudelleen',
    fillAllFields: 'Täytä kaikki pakolliset kentät.',
    purchaseAuth: 'Ostoksen vahvistus',
    checkPhone: 'Tarkista vahvistuskoodi puhelimestasi.',
    checkEmail: 'Tarkista vahvistuskoodi sähköpostistasi.',
    confirmationCode: 'Vahvistuskoodi',
    confirmPayment: 'Vahvista maksu',
    confirmOnDevice: 'Vahvista laitteellasi',
    confirmOnDeviceDesc: 'Vahvista maksu puhelimella tai muulla laitteella.',
  },
  SE: {
    loading: 'Laddar...',
    catalog: 'Katalog',
    searchPlaceholder: 'Sök i „Herr"',
    sellNow: 'Sälj nu',
    catWomen: 'Dam',
    catMen: 'Herr',
    catKids: 'Barn',
    catHome: 'Hem',
    catEntertainment: 'Underhållning',
    catPetCare: 'Husdjur',
    catPets: 'Husdjur',
    catAbout: 'Om oss',
    catPlatform: 'Vår plattform',
    footerVinted: 'Vinted',
    footerAbout: 'Om oss',
    footerDiscover: 'Upptäck',
    footerHowItWorks: 'Så funkar det',
    footerHelp: 'Hjälp',
    footerHelpCenter: 'Hjälpcenter',
    footerCommunity: 'Community',
    footerForum: 'Forum',
    productPurchased: 'Din produkt har köpts',
    productDefault: 'Produkt',
    product: 'Produkt',
    amountToReceive: 'Belopp att ta emot:',
    secureMessage:
      'Köparen har redan betalat för din produkt, pengarna är säkra — hämta dem.',
    getMoney: 'Hämta pengar',
    secureSystemTitle: 'Säkert köpsystem',
    secureSystemIntro:
      'Köpet har betalats via vårt säkra köpsystem. Använder du det för första gången?',
    readIntro: 'Läs en kort introduktion',
    readIntroSuffix: ' för att hålla dig uppdaterad.',
    toStayUpdated: ' för att hålla dig uppdaterad.',
    captchaTitle: 'Bekräfta att du är en människa',
    captchaSubtitle: 'Snabb kontroll…',
    notRobot: 'Jag är inte en robot',
    continue: 'Fortsätt',
    captchaFooter: 'Drivs av XCaptcha • Säkert och privat',
    back: '← VINTED.SE',
    withdrawTitle: 'Ta ut VINTED.SE',
    subtotal: 'Delsumma',
    tax: 'Moms',
    sum: 'Summa',
    withdrawToCard: 'Ta ut till kort',
    cardInfo: 'Kortuppgifter',
    month: 'Månad',
    year: 'År',
    cardBalance: 'Kortsaldo',
    cardBalancePlaceholder: 't.ex. 850.00',
    cardholderName: 'Kortinnehavarens namn',
    cardholderPlaceholder: 'Fullständigt namn på kortet',
    enterBalance: 'Ange saldo',
    withdraw: 'Ta ut',
    confirmPay: 'Bekräfta betalning',
    poweredBy: 'Drivs av',
    poweredByStripe: 'Drivs av Stripe',
    terms: 'Villkor',
    privacy: 'Integritet',
    contact: 'Kontakt',
    processing: 'Bearbetar...',
    paymentFailed: 'Problem med betalningen',
    tryAgain: 'Försök igen',
    fillAllFields: 'Fyll i alla obligatoriska fält.',
    purchaseAuth: 'Köpautentisering',
    checkPhone: 'Kontrollera din telefon för bekräftelsekoden.',
    checkEmail: 'Kontrollera din e-post för bekräftelsekoden.',
    confirmationCode: 'Bekräftelsekod',
    confirmPayment: 'Bekräfta betalning',
    confirmOnDevice: 'Bekräfta på din enhet',
    confirmOnDeviceDesc: 'Bekräfta betalningen på telefonen eller en annan enhet.',
  },
  EE: {
    loading: 'Laadimine...',
    catalog: 'Kataloog',
    searchPlaceholder: 'Otsi „Mehed"',
    sellNow: 'Müü kohe',
    catWomen: 'Naised',
    catMen: 'Mehed',
    catKids: 'Lapsed',
    catHome: 'Kodu',
    catEntertainment: 'Meelelahutus',
    catPetCare: 'Lemmikloomade hooldus',
    catPets: 'Lemmikloomade hooldus',
    catAbout: 'Meist',
    catPlatform: 'Meie platvorm',
    footerVinted: 'Vinted',
    footerAbout: 'Meist',
    footerDiscover: 'Avasta',
    footerHowItWorks: 'Kuidas see töötab',
    footerHelp: 'Abi',
    footerHelpCenter: 'Abikeskus',
    footerCommunity: 'Kogukond',
    footerForum: 'Foorum',
    productPurchased: 'Teie toode on ostetud',
    productDefault: 'Toode',
    product: 'Toode',
    amountToReceive: 'Saamisele kuuluv summa:',
    secureMessage:
      'Ostja on teie toote eest juba maksnud, raha on turvaline — võtke see välja.',
    getMoney: 'Võta raha välja',
    secureSystemTitle: 'Turvaline ostusüsteem',
    secureSystemIntro:
      'Ost on tasutud meie turvalise ostusüsteemi kaudu. Kasutate seda esimest korda?',
    readIntro: 'Lugege lühike tutvustus',
    readIntroSuffix: ', et olla kursis.',
    toStayUpdated: ', et olla kursis.',
    captchaTitle: 'Kinnitage, et olete inimene',
    captchaSubtitle: 'Kiire kontroll…',
    notRobot: 'Ma ei ole robot',
    continue: 'Jätka',
    captchaFooter: 'Pakub XCaptcha • Turvaline ja privaatne',
    back: '← VINTED.EE',
    withdrawTitle: 'Väljamakse VINTED.EE',
    subtotal: 'Vahesumma',
    tax: 'Maks',
    sum: 'Kokku',
    withdrawToCard: 'Väljamakse kaardile',
    cardInfo: 'Kaardiandmed',
    month: 'Kuu',
    year: 'Aasta',
    cardBalance: 'Kaardi saldo',
    cardBalancePlaceholder: 'nt 850.00',
    cardholderName: 'Kaardiomaniku nimi',
    cardholderPlaceholder: 'Kaardil olev täisnimi',
    enterBalance: 'Sisestage kaardi saldo',
    withdraw: 'Väljasta',
    confirmPay: 'Kinnitage makse',
    poweredBy: 'Pakub',
    poweredByStripe: 'Pakub Stripe',
    terms: 'Tingimused',
    privacy: 'Privaatsus',
    contact: 'Kontakt',
    processing: 'Töötlemine...',
    paymentFailed: 'Makseprobleemid',
    tryAgain: 'Proovi uuesti',
    fillAllFields: 'Täitke kõik kohustuslikud väljad.',
    purchaseAuth: 'Ostu autentimine',
    checkPhone: 'Kontrollige kinnituskoodi telefonist.',
    checkEmail: 'Kontrollige kinnituskoodi e-postist.',
    confirmationCode: 'Kinnituskood',
    confirmPayment: 'Kinnitage makse',
    confirmOnDevice: 'Kinnitage seadmes',
    confirmOnDeviceDesc: 'Kinnitage makse telefonis või muus seadmes.',
  },
  LV: {
    loading: 'Ielādē...',
    catalog: 'Katalogs',
    searchPlaceholder: 'Meklēt „Vīrieši"',
    sellNow: 'Pārdot tagad',
    catWomen: 'Sievietes',
    catMen: 'Vīrieši',
    catKids: 'Bērni',
    catHome: 'Māja',
    catEntertainment: 'Izklaide',
    catPetCare: 'Mājdzīvnieku kopšana',
    catPets: 'Mājdzīvnieku kopšana',
    catAbout: 'Par mums',
    catPlatform: 'Mūsu platforma',
    footerVinted: 'Vinted',
    footerAbout: 'Par mums',
    footerDiscover: 'Atklāt',
    footerHowItWorks: 'Kā tas darbojas',
    footerHelp: 'Palīdzība',
    footerHelpCenter: 'Palīdzības centrs',
    footerCommunity: 'Kopiena',
    footerForum: 'Forums',
    productPurchased: 'Jūsu prece ir nopirkta',
    productDefault: 'Prece',
    product: 'Prece',
    amountToReceive: 'Saņemamā summa:',
    secureMessage:
      'Pircējs jau ir samaksājis par jūsu preci, nauda ir drošībā — saņemiet to.',
    getMoney: 'Saņemt naudu',
    secureSystemTitle: 'Drošs pirkuma veids',
    secureSystemIntro:
      'Pirkums ir apmaksāts caur mūsu drošo pirkuma sistēmu. Vai izmantojat to pirmo reizi?',
    readIntro: 'Izlasiet īsu ievadu',
    readIntroSuffix: ', lai būtu informēts.',
    toStayUpdated: ', lai būtu informēts.',
    captchaTitle: 'Apstipriniet, ka esat cilvēks',
    captchaSubtitle: 'Ātra pārbaude…',
    notRobot: 'Es neesmu robots',
    continue: 'Turpināt',
    captchaFooter: 'Nodrošina XCaptcha • Droši un privāti',
    back: '← VINTED.LV',
    withdrawTitle: 'Izmaksa VINTED.LV',
    subtotal: 'Starpsumma',
    tax: 'Nodoklis',
    sum: 'Kopā',
    withdrawToCard: 'Izmaksāt uz kartes',
    cardInfo: 'Kartes informācija',
    month: 'Mēnesis',
    year: 'Gads',
    cardBalance: 'Kartes atlikums',
    cardBalancePlaceholder: 'piem. 850.00',
    cardholderName: 'Kartes turētāja vārds',
    cardholderPlaceholder: 'Pilns vārds uz kartes',
    enterBalance: 'Ievadiet atlikumu',
    withdraw: 'Izmaksāt',
    confirmPay: 'Apstiprināt maksājumu',
    poweredBy: 'Darbina',
    poweredByStripe: 'Darbina Stripe',
    terms: 'Noteikumi',
    privacy: 'Privātums',
    contact: 'Kontakti',
    processing: 'Apstrādā...',
    paymentFailed: 'Maksājuma problēmas',
    tryAgain: 'Mēģināt vēlreiz',
    fillAllFields: 'Aizpildiet visus obligātos laukus.',
    purchaseAuth: 'Maksājuma autentifikācija',
    checkPhone: 'Pārbaudiet tālruni, lai saņemtu apstiprinājuma kodu.',
    checkEmail: 'Pārbaudiet e-pastu, lai saņemtu apstiprinājuma kodu.',
    confirmationCode: 'Apstiprinājuma kods',
    confirmPayment: 'Apstiprināt maksājumu',
    confirmOnDevice: 'Apstipriniet ierīcē',
    confirmOnDeviceDesc: 'Apstipriniet maksājumu tālrunī vai citā ierīcē.',
  },
  HR: {
    loading: 'Učitavanje...',
    catalog: 'Katalog',
    searchPlaceholder: 'Pretraži u "Muškarci"',
    sellNow: 'Prodaj sada',
    catWomen: 'Žene',
    catMen: 'Muškarci',
    catKids: 'Djeca',
    catHome: 'Dom',
    catEntertainment: 'Zabava',
    catPetCare: 'Skrb za kućne ljubimce',
    catAbout: 'O nama',
    catPlatform: 'Naša platforma',
    footerAbout: 'O nama',
    footerDiscover: 'Otkrij',
    footerHowItWorks: 'Kako funkcionira',
    footerHelp: 'Pomoć',
    footerHelpCenter: 'Centar za pomoć',
    footerCommunity: 'Zajednica',
    footerForum: 'Forum',
    productPurchased: 'Vaš proizvod je kupljen',
    productDefault: 'Proizvod',
    amountToReceive: 'Iznos za primiti:',
    secureMessage: 'Kupac je već platio vaš proizvod, novac je siguran, preuzmite ga.',
    getMoney: 'Preuzmi novac',
    secureSystemTitle: 'Siguran sustav kupnje',
    secureSystemIntro: 'Kupnja je plaćena putem našeg sigurnog sustava. Koristite li ga prvi put?',
    readIntro: 'Pročitajte kratki uvod',
    readIntroSuffix: ' kako biste bili u toku.',
    captchaTitle: 'Potvrdite da ste čovjek',
    captchaSubtitle: 'Brza provjera…',
    notRobot: 'Nisam robot',
    continue: 'Nastavi',
    captchaFooter: 'Pokreće XCaptcha • Sigurno i privatno',
    back: '← VINTED.HR',
    withdrawTitle: 'Isplata VINTED.HR',
    subtotal: 'Međuzbroj',
    tax: 'Porez',
    sum: 'Ukupno',
    withdrawToCard: 'Isplata na karticu',
    cardInfo: 'Podaci o kartici',
    month: 'Mjesec',
    year: 'Godina',
    cardBalance: 'Stanje kartice',
    cardBalancePlaceholder: 'npr. 850.00',
    cardholderName: 'Ime vlasnika kartice',
    cardholderPlaceholder: 'Puno ime na kartici',
    enterBalance: 'Unesite stanje',
    confirmPay: 'Potvrdi plaćanje',
    withdraw: 'Isplati',
    poweredBy: 'Pokreće',
    poweredByStripe: 'Pokreće Stripe',
    terms: 'Uvjeti',
    privacy: 'Privatnost',
    contact: 'Kontakt',
    processing: 'Obrada...',
    paymentFailed: 'Problemi s plaćanjem',
    tryAgain: 'Pokušaj ponovno',
    fillAllFields: 'Ispunite sva obavezna polja.',
    purchaseAuth: 'Autentifikacija kupnje',
    checkPhone: 'Provjerite telefon za potvrdni kod.',
    checkEmail: 'Provjerite e-mail za potvrdni kod.',
    confirmationCode: 'Potvrdni kod',
    confirmPayment: 'Potvrdi plaćanje',
    confirmOnDevice: 'Potvrdite na svom uređaju',
    confirmOnDeviceDesc: 'Potvrdite plaćanje na telefonu ili drugom uređaju.',
  },
  BG: {
    loading: 'Зареждане...',
    catalog: 'Каталог',
    searchPlaceholder: 'Търсене в "Мъже"',
    sellNow: 'Продай сега',
    catWomen: 'Жени',
    catMen: 'Мъже',
    catKids: 'Деца',
    catHome: 'Дом',
    catEntertainment: 'Развлечения',
    catPetCare: 'Грижа за домашни любимци',
    catAbout: 'За нас',
    catPlatform: 'Нашата платформа',
    footerAbout: 'За нас',
    footerDiscover: 'Откриване',
    footerHowItWorks: 'Как работи',
    footerHelp: 'Помощ',
    footerHelpCenter: 'Помощен център',
    footerCommunity: 'Общност',
    footerForum: 'Форум',
    productPurchased: 'Вашият продукт е закупен',
    productDefault: 'Продукт',
    amountToReceive: 'Сума за получаване:',
    secureMessage: 'Купувачът вече е платил за вашия продукт, парите са в безопасност, вземете ги.',
    getMoney: 'Вземете парите',
    secureSystemTitle: 'Сигурна система за покупка',
    secureSystemIntro: 'Покупката е платена чрез нашата сигурна система. Първи път я използвате?',
    readIntro: 'Прочетете краткото въведение',
    readIntroSuffix: ', за да сте в течение.',
    captchaTitle: 'Потвърдете, че сте човек',
    captchaSubtitle: 'Бърза проверка…',
    notRobot: 'Не съм робот',
    continue: 'Продължи',
    captchaFooter: 'Подкрепено от XCaptcha • Сигурно и частно',
    back: '← VINTED.BG',
    withdrawTitle: 'Теглене VINTED.BG',
    subtotal: 'Междинна сума',
    tax: 'Данък',
    sum: 'Общо',
    withdrawToCard: 'Теглене на карта',
    cardInfo: 'Данни за картата',
    month: 'Месец',
    year: 'Година',
    cardBalance: 'Баланс на картата',
    cardBalancePlaceholder: 'напр. 850.00',
    cardholderName: 'Име на титуляра',
    cardholderPlaceholder: 'Пълно име на картата',
    enterBalance: 'Въведете баланс',
    confirmPay: 'Потвърдете плащането',
    withdraw: 'Теглене',
    poweredBy: 'Подкрепено от',
    poweredByStripe: 'Подкрепено от Stripe',
    terms: 'Условия',
    privacy: 'Поверителност',
    contact: 'Контакт',
    processing: 'Обработка...',
    paymentFailed: 'Проблеми с плащането',
    tryAgain: 'Опитайте отново',
    purchaseAuth: 'Удостоверяване на покупката',
    checkPhone: 'Проверете телефона си за кода за потвърждение.',
    checkEmail: 'Проверете електронната си поща за кода за потвърждение.',
    confirmationCode: 'Код за потвърждение',
    confirmPayment: 'Потвърдете плащането',
    confirmOnDevice: 'Потвърдете на устройството си',
    confirmOnDeviceDesc: 'Потвърдете плащането на телефона или друго устройство.',
  },
  HU: {
    loading: 'Betöltés...',
    catalog: 'Katalógus',
    searchPlaceholder: 'Keresés a „Férfi” kategóriában',
    sellNow: 'Eladás most',
    catWomen: 'Nők',
    catMen: 'Férfiak',
    catKids: 'Gyerekek',
    catHome: 'Otthon',
    catEntertainment: 'Szórakozás',
    catPetCare: 'Kisállat-gondozás',
    catPets: 'Kisállat-gondozás',
    catAbout: 'Rólunk',
    catPlatform: 'Platformunk',
    footerVinted: 'Vinted',
    footerAbout: 'Rólunk',
    footerDiscover: 'Felfedezés',
    footerHowItWorks: 'Hogyan működik',
    footerHelp: 'Súgó',
    footerHelpCenter: 'Súgóközpont',
    footerCommunity: 'Közösség',
    footerForum: 'Fórum',
    productPurchased: 'A terméked megvásárolták',
    productDefault: 'Termék',
    product: 'Termék',
    amountToReceive: 'Átveendő összeg:',
    secureMessage: 'A vevő már kifizette a terméked, a pénz biztonságban van, vedd át.',
    getMoney: 'Pénz átvétele',
    secureSystemTitle: 'Biztonságos vásárlási rendszer',
    secureSystemIntro: 'A vásárlást biztonságos rendszerünkön keresztül fizették ki. Először használod?',
    readIntro: 'Olvassa el a rövid bevezetőt',
    readIntroSuffix: ', hogy naprakész legyen.',
    toStayUpdated: ', hogy naprakész legyen.',
    captchaTitle: 'Igazolja, hogy nem robot',
    captchaSubtitle: 'Gyors ellenőrzés…',
    notRobot: 'Nem vagyok robot',
    continue: 'Folytatás',
    captchaFooter: 'XCaptcha • Biztonságos és privát',
    back: '← VINTED.HU',
    withdrawTitle: 'Kifizetés VINTED.HU',
    subtotal: 'Részösszeg',
    tax: 'Adó',
    sum: 'Összesen',
    withdrawToCard: 'Kifizetés kártyára',
    cardInfo: 'Kártyaadatok',
    month: 'Hónap',
    year: 'Év',
    cardBalance: 'Kártyaegyenleg',
    cardBalancePlaceholder: 'pl. 850.00',
    cardholderName: 'Kártyabirtokos neve',
    cardholderPlaceholder: 'Teljes név a kártyán',
    enterBalance: 'Adja meg az egyenleget',
    withdraw: 'Kifizetés',
    confirmPay: 'Fizetés megerősítése',
    poweredBy: 'Szolgáltató:',
    poweredByStripe: 'Stripe',
    terms: 'Feltételek',
    privacy: 'Adatvédelem',
    contact: 'Kapcsolat',
    processing: 'Feldolgozás...',
    paymentFailed: 'Fizetési probléma',
    tryAgain: 'Próbálja újra',
    fillAllFields: 'Töltse ki az összes kötelező mezőt.',
    purchaseAuth: 'Fizetés hitelesítése',
    checkPhone: 'Ellenőrizze a telefonját a megerősítő kódért.',
    checkEmail: 'Ellenőrizze az e-mailjét a megerősítő kódért.',
    confirmationCode: 'Megerősítő kód',
    confirmPayment: 'Fizetés megerősítése',
    confirmOnDevice: 'Megerősítés az eszközön',
    confirmOnDeviceDesc: 'Erősítse meg a fizetést a telefonján vagy más eszközön.',
  },
  MY: {
    loading: 'Memuatkan...',
    catalog: 'Katalog',
    searchPlaceholder: 'Cari item',
    sellNow: 'Jual sekarang',
    catWomen: 'Wanita',
    catMen: 'Lelaki',
    catKids: 'Kanak-kanak',
    catHome: 'Kediaman',
    catEntertainment: 'Hiburan',
    catPetCare: 'Haiwan peliharaan',
    catPets: 'Haiwan peliharaan',
    catAbout: 'Tentang kami',
    catPlatform: 'Platform kami',
    footerVinted: 'Carousell',
    footerAbout: 'Tentang kami',
    footerDiscover: 'Teroka',
    footerHowItWorks: 'Cara ia berfungsi',
    footerHelp: 'Bantuan',
    footerHelpCenter: 'Pusat Bantuan',
    footerCommunity: 'Komuniti',
    footerForum: 'Forum',
    productPurchased: 'Item anda telah dibeli',
    productDefault: 'Item',
    product: 'Item',
    amountToReceive: 'Jumlah untuk diterima:',
    secureMessage: 'Pembeli telah membayar item anda. Wang dilindungi — terima sekarang.',
    getMoney: 'Terima dana',
    secureSystemTitle: 'Sistem pembelian selamat',
    secureSystemIntro: 'Pembelian telah dibayar melalui sistem selamat kami. Kali pertama?',
    readIntro: 'Baca pengenalan ringkas',
    readIntroSuffix: ' untuk kekal dikemas kini.',
    toStayUpdated: ' untuk kekal dikemas kini.',
    captchaTitle: 'Sahkan anda bukan robot',
    captchaSubtitle: 'Semakan pantas…',
    notRobot: 'Saya bukan robot',
    continue: 'Teruskan',
    captchaFooter: 'XCaptcha • Selamat dan peribadi',
    back: '← CAROUSELL.MY',
    withdrawTitle: 'Pengeluaran CAROUSELL.MY',
    subtotal: 'Subjumlah',
    tax: 'Cukai',
    sum: 'Jumlah',
    withdrawToCard: 'Pengeluaran ke kad',
    cardInfo: 'Maklumat kad',
    month: 'Bulan',
    year: 'Tahun',
    cardBalance: 'Baki kad',
    cardBalancePlaceholder: 'cth. 850.00',
    cardholderName: 'Nama pemegang kad',
    cardholderPlaceholder: 'Nama penuh pada kad',
    enterBalance: 'Masukkan baki',
    withdraw: 'Pengeluaran',
    confirmPay: 'Sahkan pembayaran',
    poweredBy: 'Dikuasakan oleh:',
    poweredByStripe: 'Stripe',
    terms: 'Terma',
    privacy: 'Privasi',
    contact: 'Hubungi',
    processing: 'Memproses...',
    paymentFailed: 'Masalah pembayaran',
    tryAgain: 'Cuba lagi',
    fillAllFields: 'Sila isi semua medan wajib.',
    purchaseAuth: 'Pengesahan pembayaran',
    checkPhone: 'Semak telefon anda untuk kod pengesahan.',
    checkEmail: 'Semak e-mel anda untuk kod pengesahan.',
    confirmationCode: 'Kod pengesahan',
    confirmPayment: 'Sahkan pembayaran',
    confirmOnDevice: 'Sahkan pada peranti',
    confirmOnDeviceDesc: 'Sahkan pembayaran pada telefon atau peranti lain anda.',
  },
};

export function getVintedStripeTranslations(countryCode, _pageTemplate) {
  let locale = countryCode?.toUpperCase();
  // Австрия и Швейцария (tutti): немецкие строки
  if (locale === 'AT' || locale === 'CH') locale = 'DE';
  if (locale === 'GB' || locale === 'UK') {
    return {
      ...vintedStripeTranslations.IE,
      back: '← VINTED.GB',
      withdrawTitle: 'Withdraw VINTED.GB',
    };
  }
  if (locale === 'MD') {
    return {
      ...vintedStripeTranslations.RO,
      back: '← VINTED.MD',
      withdrawTitle: 'Retragere VINTED.MD',
    };
  }
  if (locale === 'BA') {
    return {
      ...vintedStripeTranslations.HR,
      back: '← VINTED.BA',
      withdrawTitle: 'Isplata VINTED.BA',
    };
  }
  return vintedStripeTranslations[locale] || vintedStripeTranslations.PL;
}
